import {AssetMetadata} from '@contentlab/types/asset';
import {ValidatedDraft} from '@contentlab/types/validatedDraft';

export enum FeatureName {
  REFORMATTING = 'reformatting',
  AI_DUBBING = 'ai_dubbing',
  REPHRASING = 'rephrasing',
  CAPTIONS = 'captions',
  AI_AVATAR = 'ai_avatar',
  UPSCALE = 'upscale',
}

export interface ProjectState {
  failedCount: number;
  inProgressCount: number;
  pendingUserActionCount: number;
  readyCount: number;
  totalFlows: number;
}

export enum ProjectStatus {
  READY = 'ready',
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  PENDING = 'pending',
  PENDING_USER_ACTION = 'pending_user_action',
  DRAFT = 'draft',
}

export enum FlowStatus {
  READY = 'ready',
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  PENDING = 'pending',
  PENDING_USER_ACTION = 'pending_user_action',
}

export interface CompactAsset {
  id: string;
  name: string;
  isArchived: boolean;
  metadata: AssetMetadata;
}

export interface UserInputDub {
  language: {code: string; name: string};
}
export interface UserInputReformatting {
  aspectRatio: string;
}
export interface UserInputCaptions {
  language: {code: string; name: string} | null;
}
export interface UserInputUpscale {
  outputResolution: number;
}

export type UserInput =
  | UserInputDub
  | UserInputReformatting
  | UserInputCaptions
  | UserInputUpscale
  | null;

export interface Flow {
  id: string;
  status: FlowStatus;
  createdAt: Date;
  inputAsset: CompactAsset;
  outputAsset: CompactAsset | null;
  userInput: UserInput | null;
  userInputVersion: number;
}

export interface FlowAssetUrls {
  inputAssetUrl?: string;
  outputAssetUrl?: string;
  inputAssetThumbnailUrl?: string;
  outputAssetThumbnailUrl?: string;
}

export interface FlowAsset {
  flow: Flow;
  flowAssetUrls: FlowAssetUrls;
}

export interface Project {
  id: string;
  name: string;
  feature: FeatureName;
  createdAt: string;
  updatedAt: string;
  filesCount: number;
  status: ProjectStatus;
  state: ProjectState;
  validatedDraft: ValidatedDraft | null;
  flows: FlowAsset[];
}
